import React from 'react';

export default function Room (){
    const handleBookNowClick = (roomType, event) => {
        event.preventDefault();
        event.stopPropagation();
        console.log(`Book Now clicked for ${roomType}`);
        
        const contactSection = document.querySelector('#contact');
        if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            console.log('Successfully scrolled to contact section');
        } else {
            console.error('Contact section not found');
            // Fallback: try to navigate to contact page
            window.location.href = '#contact';
        }
    };
    return(
    <section id="rooms" className="content-section light rooms-section">
        <div className="container">
            <h2 className="display-5 fw-bold text-center mb-5 rooms-title">Luxurious Accommodations</h2>
            <div className="row">
                <div className="col-lg-4 col-md-6 mb-4 stagger-animation">
                    <div className="card room-card-enhanced h-100">
                        <img src="/Images/deluxeroom.jpg" className="card-img-top" alt="Deluxe Room"/>
                        <div className="card-body">
                            <h5 className="room-title-enhanced">Deluxe Room</h5>
                            <p className="room-description-enhanced">Spacious rooms with modern amenities and stunning views of the fort and mountains.</p>
                            <ul className="room-features-enhanced">
                                <li><i className="fas fa-check"></i>King-size bed with premium linens</li>
                                <li><i className="fas fa-check"></i>Panoramic mountain views</li>
                                <li><i className="fas fa-check"></i>Rainfall shower</li>
                                <li><i className="fas fa-check"></i>Breakfast and Dinner included</li>
                            </ul>
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="room-price-enhanced">₹5,400/night</span>
                                <button onClick={(e) => handleBookNowClick('Deluxe Room', e)} className="btn room-button-enhanced">Book Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4 stagger-animation">
                    <div className="card room-card-enhanced h-100">
                        <img src="/Images/executiverooms.jpg" className="card-img-top" alt="Executive Suite"/>
                        <div className="card-body">
                            <h5 className="room-title-enhanced">Executive Suite</h5>
                            <p className="room-description-enhanced">Luxurious suite with separate living area and 360° panoramic views of the entire valley.</p>
                            <ul className="room-features-enhanced">
                                <li><i className="fas fa-check"></i>Separate living room & bedroom</li>
                                <li><i className="fas fa-check"></i>360° panoramic views</li>
                                <li><i className="fas fa-check"></i>Premium amenities & services</li>
                                <li><i className="fas fa-check"></i>Private terrace</li>
                                <li><i className="fas fa-check"></i>Breakfast and Dinner included</li>
                            </ul>
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="room-price-enhanced">₹5,400/night</span>
                                <button onClick={(e) => handleBookNowClick('Executive Suite', e)} className="btn room-button-enhanced">Book Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4 stagger-animation">
                    <div className="card room-card-enhanced h-100">
                        <img src="/Images/39.jpg" className="card-img-top" alt="Nature Cottage" style={{height: '100%'}}/>
                        <div className="card-body" style={{height: '100%'}}>
                            <h5 className="room-title-enhanced">Nature Cottage</h5>
                            <p className="room-description-enhanced">Charming cottage nestled in the garden with direct access to nature trails and wildlife.</p>
                            <ul className="room-features-enhanced">
                                <li><i className="fas fa-check"></i>Direct garden access</li>
                                <li><i className="fas fa-check"></i>Nature immersion experience</li>
                                <li><i className="fas fa-check"></i>Wildlife viewing opportunities</li>
                                <li><i className="fas fa-check"></i>Breakfast and Dinner included</li>
                            </ul>
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="room-price-enhanced">₹18,100/night</span>
                                <button onClick={(e) => handleBookNowClick('Nature Cottage', e)} className="btn room-button-enhanced">Book Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    )
}